import { createEffect, createSignal, For, onCleanup, onMount } from 'solid-js';
import styles from './ChatLog.module.css';
import { formatMinecraftText } from './MinecraftText';

const SCROLL_TOLERANCE_PX = 32;

const ChatLog = (props: { log: string[] }) => {
  let chatContainer: HTMLDivElement | undefined;
  let stickToBottom = true;
  let rafId = 0;
  const [showJumpButton, setShowJumpButton] = createSignal(false);

  const isNearBottom = () => {
    if (!chatContainer) return true;
    const distance = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight;
    return distance <= SCROLL_TOLERANCE_PX;
  };

  const scrollToBottom = () => {
    if (!chatContainer) return;
    chatContainer.scrollTop = chatContainer.scrollHeight;
    stickToBottom = true;
    setShowJumpButton(false);
  };

  const handleScroll = () => {
    const near = isNearBottom();
    stickToBottom = near;
    setShowJumpButton(!near);
  };

  createEffect(() => {
    props.log.length;
    if (!stickToBottom) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      if (chatContainer) chatContainer.scrollTop = chatContainer.scrollHeight;
    });
  });

  onMount(() => {
    chatContainer?.addEventListener('scroll', handleScroll, { passive: true });
    scrollToBottom();
  });

  onCleanup(() => {
    chatContainer?.removeEventListener('scroll', handleScroll);
    if (rafId) cancelAnimationFrame(rafId);
  });

  return (
    <div class={styles.container}>
      <div class="mc chatlog" ref={chatContainer}>
        <For each={props.log}>
          {(line) => <p>{formatMinecraftText(line)}</p>}
        </For>
      </div>
      {showJumpButton() && (
        <button class={styles.scrollButton} onClick={scrollToBottom}>
          Scroll to Bottom
        </button>
      )}
    </div>
  );
};

export default ChatLog;
